import Button from '../ui/Button';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-4 w-4">
    <path
      d="M12 5v14M5 12h14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

function PageHeader({ onAddTransaction }) {
  return (
    <header className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1 text-[11px] font-mono uppercase tracking-[0.2em] text-white/55">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-300 shadow-[0_0_10px] shadow-emerald-300/60" />
            Módulo 01
          </span>
          <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-white/35">
            · 10 · ago · 2026
          </span>
        </div>
        <h1 className="font-serif text-5xl leading-[0.95] tracking-tight sm:text-6xl">
          <span className="italic text-gradient">Transacciones</span>
        </h1>
        <p className="max-w-xl text-sm leading-relaxed text-white/55 sm:text-[15px]">
          Registra cada movimiento de tus ingresos, egresos y ahorros personales.
          Mantén tus presupuestos sincronizados con tu día a día financiero.
        </p>
      </div>
      <Button variant="secondary" onClick={onAddTransaction} icon={PlusIcon}>
        Nueva transacción
      </Button>
    </header>
  );
}

export default PageHeader;